!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (n, r) {
  return i = {}, o.m = c = {
    0: function (e, t) {
      e.exports = n;
    },
    1: function (e, t) {
      e.exports = r;
    },
    786: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return o;
      });
      var t = n(0),
        r = n.n(t),
        t = n(1),
        n = n.n(t),
        t = function () {
          return r.a.createElement("g", {
            fill: "none"
          }, r.a.createElement("path", {
            fill: "#00A8FF",
            d: "M7.984 9.946a8.435 8.435 0 0 1-1.51-4.375c-.006-.108-.006-.214-.006-.325v-.009c0-1.255.362-2.399.959-3.263C7.759 1.397 8.498.812 9.451.428c-.43.164-.843.378-1.239.632-6.887 4.276-3.156 15.27-.344 18.669.04.05.344.39.439.483 1.765 1.766 4.294 2.06 5.645.657 1.318-1.366 1.026-3.848-.633-5.608-1.744-1.912-3.722-2.888-5.335-5.315"
          }), r.a.createElement("path", {
            fill: "#00A8FF",
            d: "M11.441.022a5.771 5.771 0 0 0-.32.018c.57-.03 1.063.06 1.4.26a2.19 2.19 0 0 1 .834.852c.265.447.4.995.4 1.6v.043c-.01 1.224-.552 2.662-1.598 3.86l-.083.094v.003a4.437 4.437 0 0 0-.252.328c-1.035 1.515-.81 3.499.502 4.428 1.312.93 3.217.453 4.255-1.066.051-.074.1-.152.146-.229C19.692 5.469 16.238-.186 11.44.022"
          }), r.a.createElement("path", {
            fill: "#F57B20",
            d: "M8.915 8.515c.146-2.52 1.744-4.474 3.57-4.363.338.022.676.127.974.276a5.18 5.18 0 0 0 .295-1.633v-.043c0-.605-.13-1.153-.398-1.6a2.249 2.249 0 0 0-.66-.74c-.056-.04-.116-.074-.174-.108-.615-.372-1.76-.366-2.937.074-1.02.381-1.814.992-2.161 1.596-.597.867-.959 2.008-.959 3.263 0 .108.003.217.01.325.066 1.512.602 3.083 1.509 4.381.733 1.103 1.54 1.91 2.368 2.637-.95-.846-1.534-2.367-1.437-4.065"
          }));
        };
      t.svg = {
        viewBox: "0 0 22 22"
      };
      var o = n()(t);
    }
  }, o.c = i, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 786);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return c[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var c, i;
});